import Breadcrumbs from "../../common/Breadcrumbs/Breadcrumbs";
import Header from "../../layout/Header/Header";
import Footer from "../../layout/Footer/Footer";
import { resetLeavesWidgetsAction } from "../../../redux/actions/LeavesWorkTimeShifts/leavesWidgetsAction";
import { workScheduleThunkAction } from "../../../redux/actions/LeavesWorkTimeShifts/thunk/workSchedule.thunk.action";
import MultiWidget from "../../common/MultiWidget/MultiWidget";
import UButton from "../../common/Button/UButton/UButton";
import AnnualCalendar from "../../common/Modal/AnnualCalendar/AnnualCalendar";
import { Modal } from "../../common/Modal/Modal";
import LeavesService from "../../../frontend.services/Leaves.service";
import { isTerminal } from "../../../constants";
import { AnnualCalendarForTerminal } from "../../common/componentsTerminal/Calendar/AnnualCalendarForTerminal";
import { getActualMonthForTerminalCalendar } from "../../../utils/getActualMonthForTerminalCalendar";

import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";

isTerminal
    ? import("./WorkScheduleTerminal.scss")
    : import("./WorkSchedule.scss");

const WorkSchedule = () => {
    const dispatch = useDispatch();
    const workSchedule = useSelector((state) => state.workTime.workSchedule);
    const [workScheduleCurrent, setWorkScheduleCurrent] = useState(workSchedule);
    const [schelduleType, setSchelduleType] = useState({ type: null, data: null });
    const [toggleState, setToggleState] = useState(1);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [firstDisplayedMonth, setFirstDisplayedMonth] = useState(1);
    const todayStr = new Date().toDateString();
    const isToday = (dateStr) => new Date(dateStr).toDateString() === todayStr;
    console.log(workSchedule);
    const dataAttributes = {
        past: {
            "list-item": "regular",
        },
        night: {
            "list-item": "night",
        },
        regular: {
            "list-item": "over",
        },
        over: {
            "list-item": "cross",
        },
    };
    useEffect(() => {
        setFirstDisplayedMonth(getActualMonthForTerminalCalendar(modalPosition.x));
    }, [modalPosition]);

    const toggleTab = (index) => {
        dispatch(resetLeavesWidgetsAction());
        setToggleState(index);
        if (index === 2) {
            if (LeavesService.getCurrentMonth() !== 1) {
                dispatch(
                    workScheduleThunkAction(
                        LeavesService.getCurrentYear(),
                        LeavesService.getCurrentMonth() - 1,
                    ),
                );
            } else if (LeavesService.getCurrentMonth() === 1) {
                dispatch(
                    workScheduleThunkAction(
                        LeavesService.getCurrentYear() - 1,
                        12,
                    ),
                );
            }
        } else {
            dispatch(
                workScheduleThunkAction(
                    LeavesService.getCurrentYear(),
                    LeavesService.getCurrentMonth(),
                ),
            );
        }
    };
    const [modalAnnual, toggleModalAnnual] = useState(false);
    const clickHandlerAnnual = (type, i, e) => {
        const { clientX, clientY } = e;
        setModalPosition({ x: clientX, y: clientY });
        setSchelduleType({
            type: "График работы",
            data: workScheduleCurrent.workPeriodForDayPicker,
        });
        toggleModalAnnual(true);
    };

    const closeHandlerAnnual = () => {
        toggleModalAnnual(false);
    };

    const openAnnualCalendar = () => {
        setSchelduleType({
            type: "График работы",
            data: workScheduleCurrent.workPeriodForDayPicker,
        });
        toggleModalAnnual(true);
    };

    useEffect(() => {
        dispatch(
            workScheduleThunkAction(
                LeavesService.getCurrentYear(),
                LeavesService.getCurrentMonth(),
            ),
        );
    }, [dispatch]);

    useEffect(() => {
        setWorkScheduleCurrent(workSchedule);
    }, [workSchedule]);

    return (
        <>
            <Header />
            <Breadcrumbs />

            <div className={isTerminal && "work-schedule__content-wrapper"}>

                <div className="work-schedule">
                    {!workScheduleCurrent ? (
                        <div style={{ textAlign: "center", width: isTerminal && "1080px" }}>
                            <ClipLoader color="#6DCDF6" />
                        </div>
                    ) : (
                        <>

                            <h1
                                style={isTerminal &&{paddingLeft: "90px"}}
                                className={"sub-header"}>
                            График работы
                            </h1>
                            <div className={isTerminal ? "work-schedule__multi-wdget-wrapper" : "leaves-multi-widget"}>

                                <MultiWidget
                                    data={workScheduleCurrent.widgets}
                                    styleParent={isTerminal ? "leaves-widgets" : "work-schedule"}
                                    // subHeader="График работы"
                                    isBackButtonEnabled
                                />
                            </div>
                            {!isTerminal && <div style={{
                                fontSize: "16px",
                                lineHeight: " 135%",
                                fontWeight: "450",
                            }}>
                            Графики/режимы работы носят информационный характер и не имеют юридической силы.
                            Руководствоваться необходимо актуальной информацией в утвержденном работодателем графике или
                            подписанном соглашении
                            </div>}

                            <div
                                className={isTerminal ? "work-schedule__nav-menu" : "navMenu"}
                                style={{ margin: !isTerminal && "20px 0 0 0" }}>
                                <div
                                    onClick={() => toggleTab(2)}
                                    className={
                                        toggleState === 2
                                            ? "documents-menu-item"
                                            : "documents-menu-item-active"
                                    }>
                                Прошлый месяц
                                </div>
                                <div
                                    onClick={() => toggleTab(1)}
                                    className={
                                        toggleState === 1
                                            ? "documents-menu-item"
                                            : "documents-menu-item-active"
                                    }>
                                Текущий месяц
                                </div>
                            </div>
                            <div className={"cross-table-controller"}>
                                <ul className={"cross-table-controller__legend"}>
                                    {
                                        workSchedule.legends && workSchedule.legends.length ?
                                            workSchedule.legends.map((legend, i) => {
                                                return (
                                                    <div key={i} className="table-container__legend ">
                                                        <div style={{
                                                            backgroundColor: legend.color,
                                                            backgroundImage: "none",
                                                            opacity: 1,
                                                        }}
                                                             className="table-container__legend__color-item"></div>
                                                        <div>— {"  "+`  ${legend.name}`}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                            : null
                                    }
                                </ul>
                            </div>

                            <table className="work-schedule__table-a">
                                <thead>
                                    <tr>
                                        <td
                                            style={{
                                                letterSpacing: "0.2em",
                                                fontSize: "12px",
                                                textTransform: "uppercase",
                                                color: "rgba(109, 110, 113, 1)",
                                                fontWeight: "450",
                                            }}>
                                    Тип
                                        </td>
                                        {workScheduleCurrent.workPeriod
                                            .length !== 0 &&
                                            workScheduleCurrent?.workPeriod?.length &&    workScheduleCurrent.workPeriod.map(
                                        (el, i) => {
                                            return (
                                                <td
                                                    key={i}
                                                    className={[
                                                        el.dayNumber === 6 || el.dayNumber === 7
                                                            ? "work-schedule-header weekendHeader"
                                                            : "work-schedule-header",
                                                        isToday(el.date) ? "work-schedule-header--today" : "",
                                                    ].join(" ")}>
                                                    <div>{el.dayShortName}</div>
                                                    <div>{new Date(el.date).getDate()}</div>
                                                </td>
                                            );
                                        },
                                    )}
                                    </tr>
                                </thead>
                                <tbody
                                    className={"work-schedule__table-a__item"}>
                                    <tr>
                                        <td
                                            style={{
                                                fontSize: "14px",
                                                color: "rgba(109, 110, 113, 1)",
                                                fontWeight: "400",
                                                textAlign: isTerminal ? "left" : "center",
                                                paddingRight: "8px",
                                            }}>
                                    График работы
                                        </td>
                                        {workScheduleCurrent.workPeriod
                                            .length !== 0 &&
                                    workScheduleCurrent.workPeriod.map(
                                        (el, i) => {
                                            console.log(el.color);
                                            return (
                                                <td
                                                    onClick={(e) =>
                                                        clickHandlerAnnual(el.typeName, i, e)
                                                    }
                                                    style={{
                                                        backgroundColor: el.color ? el.color : "#fff",
                                                    }}
                                                    className={
                                                        // el.dayTypeName ===
                                                        // "рабочий" ||
                                                        // el.dayTypeName ===
                                                        // "рабочий сокращенный"
                                                        //      el.dayPass ===
                                                        //     true
                                                        //         ? "work-schedule__table pass"
                                                        //         :
                                                                 "work-schedule__table"
                                                        //     : "work-schedule__table weekend"
                                                    }
                                                    key={i}></td>
                                            );
                                        },
                                    )}
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    )}
                    <UButton onClick={openAnnualCalendar}>
                        График работы на год
                    </UButton>
                    {isTerminal
                        ? (
                            <AnnualCalendarForTerminal
                                firstDisplayedMonth={firstDisplayedMonth}
                                shown={modalAnnual}
                                onClose={closeHandlerAnnual}
                                type={schelduleType}
                                year={toggleState === 1 ? LeavesService.getCurrentYear() : LeavesService.getYearPrevMonth()}
                                mausePosition={modalPosition}
                            />
                        )
                        : (
                            <Modal shown={modalAnnual} close={closeHandlerAnnual}>
                                <AnnualCalendar
                                    type={schelduleType}
                                    year={
                                        toggleState === 1
                                            ? LeavesService.getCurrentYear()
                                            : LeavesService.getYearPrevMonth()
                                    }
                                    disableOtherMonth
                                    legends={workScheduleCurrent?.colorDayTypes}
                                />
                            </Modal>
                        )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default WorkSchedule;
